module.exports = __webpack_public_path__ + "img/VAMPIRO_V2.8458690e.jpg";